"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _layouts = require("@seedlang/layouts");
var _stores = require("@seedlang/stores");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
var _models = require("@seedlang/models");
var _overlay_ui = _interopRequireDefault(require("./overlay_ui"));
var _exercise_ui = _interopRequireDefault(require("./exercise_ui"));
var _deck_ui = _interopRequireDefault(require("./deck_ui"));
var _tree_ui = _interopRequireDefault(require("./tree_ui"));
var _after_auth = _interopRequireDefault(require("./after_auth"));
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var AppUI = (_class = /*#__PURE__*/function (_RootState) {
  function AppUI(parent) {
    var _this;
    _classCallCheck(this, AppUI);
    _this = _callSuper(this, AppUI);
    _this.SIMULATE_MOBILE_AUTH = false;
    // also exists in api.js
    _this.ENABLE_MOBILE_LOGGING = typeof __DEV__ !== 'undefined' ? __DEV__ : typeof process !== 'undefined' ? process.env.NODE_ENV !== 'production' : false;
    _initializerDefineProperty(_this, "allowPageScroll", _descriptor, _this);
    _initializerDefineProperty(_this, "notificationsOpened", _descriptor2, _this);
    _initializerDefineProperty(_this, "streakPopupOpened", _descriptor3, _this);
    _initializerDefineProperty(_this, "usingDataSaverHeader", _descriptor4, _this);
    _initializerDefineProperty(_this, "registrationSubmitted", _descriptor5, _this);
    _initializerDefineProperty(_this, "hideOnboarding", _descriptor6, _this);
    _initializerDefineProperty(_this, "deletedAccountEmail", _descriptor7, _this);
    _initializerDefineProperty(_this, "expandedEmailRegistrationFields", _descriptor8, _this);
    _initializerDefineProperty(_this, "loadingReviews", _descriptor9, _this);
    _initializerDefineProperty(_this, "blockRouteToHome", _descriptor0, _this);
    _initializerDefineProperty(_this, "reloadReviewDecks", _descriptor1, _this);
    _initializerDefineProperty(_this, "currentlyViewedMembership", _descriptor10, _this);
    _initializerDefineProperty(_this, "routeToMobile", _descriptor11, _this);
    _initializerDefineProperty(_this, "vocabWordTypeId", _descriptor12, _this);
    _initializerDefineProperty(_this, "nativeDevice", _descriptor13, _this);
    _initializerDefineProperty(_this, "mobileTabChangeTimeStamp", _descriptor14, _this);
    _initializerDefineProperty(_this, "showUpdateAppModal", _descriptor15, _this);
    _initializerDefineProperty(_this, "showUpdateLangModal", _descriptor16, _this);
    _initializerDefineProperty(_this, "showImagePickerModal", _descriptor17, _this);
    _initializerDefineProperty(_this, "showVocabModal", _descriptor18, _this);
    _initializerDefineProperty(_this, "clickedLinkId", _descriptor19, _this);
    _initializerDefineProperty(_this, "updatedDeviceLanguageId", _descriptor20, _this);
    _initializerDefineProperty(_this, "showFirstDeckCompletionModal", _descriptor21, _this);
    _initializerDefineProperty(_this, "onboardingDeckType", _descriptor22, _this);
    _initializerDefineProperty(_this, "onboardingDeckId", _descriptor23, _this);
    _initializerDefineProperty(_this, "onboardingTreeNodeId", _descriptor24, _this);
    _initializerDefineProperty(_this, "pageHasScrolled", _descriptor25, _this);
    _initializerDefineProperty(_this, "pageExpanded", _descriptor26, _this);
    _initializerDefineProperty(_this, "contentTreeScrollPosition", _descriptor27, _this);
    _initializerDefineProperty(_this, "worksheetGridScrollPosition", _descriptor28, _this);
    _initializerDefineProperty(_this, "contractedModulesAry", _descriptor29, _this);
    _initializerDefineProperty(_this, "wordStores", _descriptor30, _this);
    _initializerDefineProperty(_this, "wordSentenceStores", _descriptor31, _this);
    _initializerDefineProperty(_this, "conjugatedVerbStringStores", _descriptor32, _this);
    _initializerDefineProperty(_this, "onboardingLevelId", _descriptor33, _this);
    _initializerDefineProperty(_this, "onboardingLanguageId", _descriptor34, _this);
    _initializerDefineProperty(_this, "isBrowser", _descriptor35, _this);
    _this.nativeLanguageOptionsForLanguageId = function (languageId) {
      var options = _this.AiLanguageOptions.slice();
      if (languageId && _constants.Languages[languageId] && !_constants.AiLanguages[languageId]) {
        options.push([languageId, _constants.Languages[languageId]]);
      }
      return options;
    };
    _this.defaultReviewDeck = function (languageId) {
      return _this.reviewDeckStore.indexData.find(function (item) {
        return item.defaultReviewDeck && item.languageId === languageId;
      });
    };
    _this.defaultReviewDeckIdForLanguageId = function (languageId) {
      var _this$reviewDeckStore;
      var defaultReviewDeck = _this.defaultReviewDeck(languageId);
      if (defaultReviewDeck) {
        return defaultReviewDeck.id;
      }
      return (_this$reviewDeckStore = _this.reviewDeckStore.indexData.filter(function (item) {
        return item.languageId === languageId;
      })[0]) === null || _this$reviewDeckStore === void 0 ? void 0 : _this$reviewDeckStore.id;
    };
    _this.setAuthUserStoreShowData = function (resp) {
      var _resp$site;
      _this.authUserStore.setShowData(resp);
      _this.api.setSiteId((resp === null || resp === void 0 || (_resp$site = resp.site) === null || _resp$site === void 0 ? void 0 : _resp$site.id) || null);
      if (_this.SIMULATE_MOBILE_AUTH) {
        if (_this.isBrowser) {
          localStorage.setItem('jwtToken', resp['jwtToken']);
        }
      }
      _this.syncWebPosthog();
    };
    _this.webPosthogTrackingAllowed = function () {
      var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.user;
      return (0, _utils.shouldTrackWebPosthog)({
        siteIsSeedlang: _this.siteIsSeedlang,
        user: user,
        allowCookies: _this.getCookieValue('allow-cookies') === true
      });
    };
    _this.posthogEventParams = function (eventType) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (0, _utils.buildWebPosthogEventProperties)({
        eventType: eventType,
        params: params,
        user: _this.user,
        site: _this.site
      });
    };
    _this.syncWebPosthog = function () {
      var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.user;
      if (_this.layout.isNative) {
        return;
      }
      (0, _utils.syncPosthogUser)(user, {
        site: _this.site,
        trackingAllowed: _this.webPosthogTrackingAllowed(user)
      });
    };
    _this.setJwtToken = function (jwtToken) {
      _this.api.setJwtToken(jwtToken);
    };
    _this.setUpdatedDeviceLanguageId = function (languageId) {
      _this.updatedDeviceLanguageId = languageId;
    };
    _this.specialCharacterListByLanguage = function (languageId) {
      var tl = _this.user.targetLanguages.find(function (item) {
        return item.languageId === languageId;
      });
      if (tl) {
        return tl.specialCharacterList;
      }
    };
    _initializerDefineProperty(_this, "userRequestPending", _descriptor36, _this);
    _this.userRequestCallbacks = [];
    _initializerDefineProperty(_this, "loadUser", _descriptor37, _this);
    _this.loadUserPromise = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var params,
        resp,
        _args = arguments;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            params = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            _context.n = 1;
            return _this.authUserStore.getShowPromise(params);
          case 1:
            resp = _context.v;
            _this.syncWebPosthog();
            return _context.a(2, resp);
        }
      }, _callee);
    }));
    _this.onMobileTabChange = function () {
      _this.mobileTabChangeTimeStamp = +new Date();
    };
    _this.afterSignOutSeedlang = function () {
      if (_this.isBrowser) {
        if (_this.SIMULATE_MOBILE_AUTH) localStorage.removeItem('jwtToken');
      }
      _this.authUserStore.getShow({}, function (resp) {
        _this.authUserStore.setShowData(resp);
        _this.routeStore.routeToNamed('landing');
      });
    };
    _this.afterSignOutMemrev = function () {
      if (_this.isBrowser) {
        if (_this.SIMULATE_MOBILE_AUTH) localStorage.removeItem('jwtToken');
      }
      _this.authUserStore.getShow({}, function (resp) {
        _this.authUserStore.setShowData(resp);
        _this.routeStore.routeToNamed(_this.route || 'memrev.home');
      });
    };
    _this.routeToSignedInHome = function () {
      var _AfterAuth$value, _this$user, _this$user2;
      var route;
      var returnPath = (_AfterAuth$value = _after_auth["default"].value) === null || _AfterAuth$value === void 0 ? void 0 : _AfterAuth$value.path;
      if (_this.authenticateStore.redirectRouteNameAfterLogin) {
        route = _this.authenticateStore.redirectRouteNameAfterLogin;
        _this.authenticateStore.redirectRouteNameAfterLogin = null;
      } else if (returnPath !== null && returnPath !== void 0 && returnPath.startsWith('/') && !returnPath.startsWith('//')) {
        _after_auth["default"].clear();
        _this.routeStore.routeTo(returnPath);
        return;
      } else if (_this.siteIsMemrev && _this.userIsLoaded && (_this$user = _this.user) !== null && _this$user !== void 0 && (_this$user = _this$user.site) !== null && _this$user !== void 0 && _this$user.signedInHomePageRoute) {
        route = _this.user.site.signedInHomePageRoute;
      } else if (_this.siteIsMemrev && !_this.userIsLoaded && (_this$user2 = _this.user) !== null && _this$user2 !== void 0 && (_this$user2 = _this$user2.site) !== null && _this$user2 !== void 0 && _this$user2.signedOutHomePageRoute) {
        route = _this.user.site.signedOutHomePageRoute;
      } else if (!window.location.href.match('ngrok') && !window.location.href.match('easy')) {
        route = 'reviews.home';
      } else {
        route = 'memrev.home';
      }
      try {
        _this.routeStore.routeToNamed(route);
      } catch (error) {
        console.error(error);
        if (_this.siteIsSeedlang) {
          _this.routeStore.routeToNamed('reviews.home');
        } else {
          _this.routeStore.routeToNamed('memrev.home');
        }
      }
    };
    _this.createXpAnimation = function (params) {
      if (params.xp > 0 && params.triviaCard) {
        _this.soundEffectStore.play('correctChime');
      } else if (params.xp > 0) {
        _this.soundEffectStore.play('correct');
      } else {
        _this.soundEffectStore.play('failure');
      }
      _this.xpState.createXpAnimation(params);
    };
    _this.onSetVocabModal = function (trainer) {
      _this.showVocabModal = trainer;
    };
    _initializerDefineProperty(_this, "toggleNotificationsOpened", _descriptor38, _this);
    _this.setNativeSoundEffectPlayer = function (nativeSoundEffectPlayer) {
      _this.soundEffectStore.setNativeSoundEffectPlayer(nativeSoundEffectPlayer);
    };
    _this.setNativeCreateEventHandler = function (callback) {
      _this.nativeCreateEventHandler = callback;
    };
    _this.getCookieValue = function (name) {
      return _this.cookieStore.getCookieValue(name);
    };
    _this.setCookieValue = function (name, value) {
      _this.cookieStore.setCookieValue(name, value);
    };
    _this.getErrorMessage = function () {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'general';
      // video, sentence
      return _constants.Constants.ERROR_MESSAGES[_this.targetLanguageId] ? _constants.Constants.ERROR_MESSAGES[_this.targetLanguageId][type] : _constants.Constants.ERROR_MESSAGES['EN'][type];
    };
    _this.routeToHome = function () {
      if (_this.blockRouteToHome) {
        return;
      }
      if (_this.user.signedOut && _this.siteIsSeedlang) {
        _this.routeStore.routeToNamed('landing');
      } else if (_this.siteIsSeedlang) {
        _this.routeStore.routeToNamed('reviews.home');
      } else if (_this.user) {
        _this.routeToSignedInHome();
      } else {
        _this.routeStore.routeToNamed('memrev.home');
      }
    };
    _initializerDefineProperty(_this, "toggleStreakPopupOpened", _descriptor39, _this);
    _this.afterGetNotificationsIndex = function (resp) {
      _this.notificationStore.setIndexData(resp);
      _this.notificationStore.clear();
      _this.user.resetUnseenNotifications();
    };
    _this.updateContractedModulesAry = function (contractedModulesAry) {
      _this.contractedModulesAry = contractedModulesAry;
    };
    _this.afterGetReviews = function (resp) {
      _this.reviewStore.setIndexData(resp);
      _this.loadingReviews = false;
    };
    _this.loadReviewDecks = function (callback) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _this.reloadReviewDecks = false;
      _this.reviewDeckStore.setLimit(200);
      _this.reviewDeckStore.getIndex({
        failureCallback: options.failureCallback,
        onRequestError: options.onRequestError
      }, callback);
    };
    _this.createWordStore = function () {
      var word = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var wordStoreId = (0, _utils.createUuid)();
      var wordStore = new _this.wordStore.constructor();
      var wordSentenceStore = new _this.wordSentenceStore.constructor();
      var conjugatedVerbStringStore = new _this.conjugatedVerbStringStore.constructor();
      if ((0, _utils.isPresent)(word)) {
        wordStore.setShowData(word);
      }
      _this.wordStores = _objectSpread(_objectSpread({}, _this.wordStores), {}, _defineProperty({}, wordStoreId, wordStore));
      _this.wordSentenceStores = _objectSpread(_objectSpread({}, _this.wordSentenceStores), {}, _defineProperty({}, wordStoreId, wordSentenceStore));
      _this.conjugatedVerbStringStores = _objectSpread(_objectSpread({}, _this.conjugatedVerbStringStores), {}, _defineProperty({}, wordStoreId, conjugatedVerbStringStore));
      return wordStoreId;
    };
    _this.getWordStore = function () {
      var wordStoreId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if ((0, _utils.isPresent)(wordStoreId) && _this.wordStores[wordStoreId]) {
        return _this.wordStores[wordStoreId];
      }
      return _this.wordStore;
    };
    _this.getWordSentenceStore = function () {
      var wordStoreId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if ((0, _utils.isPresent)(wordStoreId) && _this.wordSentenceStores[wordStoreId]) {
        return _this.wordSentenceStores[wordStoreId];
      }
      return _this.wordSentenceStore;
    };
    _this.getConjugatedVerbStringStore = function () {
      var wordStoreId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if ((0, _utils.isPresent)(wordStoreId) && _this.conjugatedVerbStringStores[wordStoreId]) {
        return _this.conjugatedVerbStringStores[wordStoreId];
      }
      return _this.conjugatedVerbStringStore;
    };
    _this.destroyWordStore = function () {
      var _this$wordStores$word, _this$wordSentenceSto, _this$conjugatedVerbS;
      var wordStoreId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!(0, _utils.isPresent)(wordStoreId)) {
        return;
      }
      (_this$wordStores$word = _this.wordStores[wordStoreId]) === null || _this$wordStores$word === void 0 || _this$wordStores$word.clearShowData();
      (_this$wordSentenceSto = _this.wordSentenceStores[wordStoreId]) === null || _this$wordSentenceSto === void 0 || _this$wordSentenceSto.clearIndexData();
      (_this$conjugatedVerbS = _this.conjugatedVerbStringStores[wordStoreId]) === null || _this$conjugatedVerbS === void 0 || _this$conjugatedVerbS.clearIndexData();
      var updatedWordStores = _objectSpread({}, _this.wordStores);
      var updatedWordSentenceStores = _objectSpread({}, _this.wordSentenceStores);
      var updatedConjugatedVerbStringStores = _objectSpread({}, _this.conjugatedVerbStringStores);
      delete updatedWordStores[wordStoreId];
      delete updatedWordSentenceStores[wordStoreId];
      delete updatedConjugatedVerbStringStores[wordStoreId];
      _this.wordStores = updatedWordStores;
      _this.wordSentenceStores = updatedWordSentenceStores;
      _this.conjugatedVerbStringStores = updatedConjugatedVerbStringStores;
    };
    _initializerDefineProperty(_this, "reloadFeed", _descriptor40, _this);
    _this.createOrUpdateUserTranslation = function (word, data, callback) {
      if (word.userTranslationId) {
        _this.userTranslationStore.update({
          data: data,
          ids: {
            userTranslationId: word.userTranslationId
          }
        });
      } else {
        data.translationId = word.id;
        _this.userTranslationStore.create({
          data: data
        }, callback);
      }
    };
    _initializerDefineProperty(_this, "gotoPrivacy", _descriptor41, _this);
    _initializerDefineProperty(_this, "gotoPartners", _descriptor42, _this);
    _initializerDefineProperty(_this, "gotoSettings", _descriptor43, _this);
    _initializerDefineProperty(_this, "gotoFaq", _descriptor44, _this);
    _initializerDefineProperty(_this, "gotoContact", _descriptor45, _this);
    _initializerDefineProperty(_this, "gotoProfile", _descriptor46, _this);
    _this.scrollToPageTop = function () {
      var behavior = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'smooth';
      var pageTopId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'page-top';
      var top = 0;
      var pageTop = document.getElementById(pageTopId);
      if ((0, _utils.isPresent)(pageTop) && !_this.topIsInView(pageTop)) {
        if ((0, _utils.isPresent)(pageTop) && pageTop.getBoundingClientRect()) {
          top += pageTop.getBoundingClientRect().top;
        }
      }
      if (_this.layout.isMobile) {
        setTimeout(function () {
          window.scroll({
            top: top,
            left: 0,
            behavior: behavior
          });
        }, 10);
      } else {
        setTimeout(function () {
          var _document$getElements;
          (_document$getElements = document.getElementsByClassName('app')[0]) === null || _document$getElements === void 0 || _document$getElements.scrollTo({
            top: top - 80,
            behavior: behavior
          });
        }, 10);
      }
    };
    _this.topIsInView = function (el) {
      var rect = el.getBoundingClientRect();
      return rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight);
    };
    _this.parent = parent;
    _this.layout = new _layouts.AppLayout(_this);
    _this.api = _stores.Api;
    _this.soundEffectStore = _stores.SoundEffectStore;
    _this.xpState = _models.XpState;
    _this.analyticStore = _stores.AnalyticStore;
    _this.podcastEpisodeStore = _stores.PodcastEpisodeStore;
    _this.gridItemStore = _stores.GridItemStore;
    _this.gridItemWorksheetStore = _stores.GridItemWorksheetStore;
    _this.referrerOptionStore = _stores.ReferrerOptionStore;
    _this.tagCategoryStore = _stores.TagCategoryStore;
    _this.levelStore = _stores.LevelStore;
    _this.authUserStore = _stores.AuthUserStore;
    _this.userStore = _stores.UserStore;
    _this.bannerNoticeStore = _stores.BannerNoticeStore;
    _this.userDeckStore = _stores.UserDeckStore;
    _this.campaignStore = _stores.CampaignStore;
    _this.wordSearchStore = _stores.WordSearchStore;
    _this.languageStore = _stores.LanguageStore;
    _this.feedEntryStore = _stores.FeedEntryStore;
    _this.followAssociationStore = _stores.FollowAssociationStore;
    _this.commentStore = _stores.CommentStore;
    _this.followingStore = _stores.FollowingStore;
    _this.followerStore = _stores.FollowerStore;
    _this.contactMessageStore = _stores.ContactMessageStore;
    _this.contactCategoryStore = _stores.ContactCategoryStore;
    _this.routeStore = _stores.RouteStore;
    _this.notificationStore = _stores.AuthUserNotificationStore;
    _this.leaderboardStore = _stores.LeaderboardStore;
    _this.dailyXpCountStore = new _stores.DailyXpCountStore();
    _this.authUserDailyXpCountStore = new _stores.DailyXpCountStore();
    _this.feedbackStore = _stores.FeedbackStore;
    _this.serverStore = _stores.ServerStore;
    _this.treeStore = _stores.TreeStore;
    _this.pageStore = _stores.PageStore;
    _this.treeNodeStore = _stores.TreeNodeStore;
    _this.subscriptionStore = _stores.SubscriptionStore;
    _this.userBannerNoticeStore = _stores.UserBannerNoticeStore;
    _this.stripeStore = _stores.StripeStore;
    _this.userSubscriptionStore = _stores.UserSubscriptionStore;
    _this.membershipStore = _stores.MembershipStore;
    _this.membershipGroupStore = _stores.MembershipGroupStore;
    _this.meaningFlagEventStore = _stores.MeaningFlagEventStore;
    _this.membershipTypeStore = _stores.MembershipTypeStore;
    _this.wordTypeStore = _stores.WordTypeStore;
    _this.wordStore = _stores.WordStore;
    _this.deckStore = _stores.DeckStore;
    _this.paypalStore = _stores.PaypalStore;
    _this.eventStore = _stores.EventStore;
    _this.sentenceStore = _stores.SentenceStore;
    _this.wordSentenceStore = _stores.WordSentenceStore;
    _this.authenticateStore = _stores.AuthenticateStore;
    _this.dashboardStore = _stores.DashboardStore;
    _this.userTranslationStore = _stores.UserTranslationStore;
    _this.cardStore = _stores.CardStore;
    _this.downloadLinkTypeStore = _stores.DownloadLinkTypeStore;
    _this.downloadLinkStore = _stores.DownloadLinkStore;
    _this.conjugatedVerbStringStore = _stores.ConjugatedVerbStringStore;
    _this.teamStore = _stores.TeamStore;
    _this.promotedRatingStore = _stores.PromotedRatingStore;
    _this.translationSourceStore = _stores.TranslationSourceStore;
    _this.reviewStore = _stores.ReviewStore;
    _this.dailyReviewSummaryStore = _stores.DailyReviewSummaryStore;
    _this.userTreeNodeStore = _stores.UserTreeNodeStore;
    _this.userGroupStore = _stores.UserGroupStore;
    _this.siteReleaseStore = _stores.SiteReleaseStore;
    _this.sentenceSubmissionStore = _stores.SentenceSubmissionStore;
    _this.revenueCatStore = _stores.RevenueCatStore;
    _this.mobileNotificationTokenStore = _stores.MobileNotificationTokenStore;
    _this.reviewDeckStore = _stores.ReviewDeckStore;
    _this.allReviewDecksStore = _stores.AllReviewDecksStore;
    _this.cardTypeStore = _stores.CardTypeStore;
    _this.faqCategoryStore = _stores.FaqCategoryStore;
    _this.faqItemStore = _stores.FaqItemStore;
    _this.groupStore = _stores.GroupStore;
    _this.navigationItemStore = _stores.NavigationItemStore;
    _this.targetLanguageStore = _stores.TargetLanguageStore;
    _this.worksheetStore = _stores.WorksheetStore;
    _this.podcastStore = _stores.PodcastStore;
    _this.siteStore = _stores.SiteStore;
    _this.csrfStore = _stores.CsrfStore;
    _this.discordUserAssociationStore = _stores.DiscordUserAssociationStore;
    _this.discordRoleStore = _stores.DiscordRoleStore;
    _this.cookieStore = _stores.CookieStore;
    _this.patreonRewardStore = _stores.PatreonRewardStore;
    _this.videoClipStore = _stores.VideoClipStore;
    _this.paymentMigrationStore = _stores.PaymentMigrationStore;
    _this.promotionStore = _stores.PromotionStore;
    return _this;
  }
  _inherits(AppUI, _RootState);
  return _createClass(AppUI, [{
    key: "user",
    get: function get() {
      return this.authUserStore.showData;
    }
  }, {
    key: "userIsLoaded",
    get: function get() {
      var _this$user3;
      return (0, _utils.isPresent)((_this$user3 = this.user) === null || _this$user3 === void 0 ? void 0 : _this$user3.id);
    }
  }, {
    key: "userId",
    get: function get() {
      if (this.userIsLoaded) {
        return this.user.id;
      }
    }
  }, {
    key: "permissions",
    get: function get() {
      var obj = (0, _utils.isPresent)(this.user.currentUserGroup) ? this.user.currentUserGroup : this.user;
      return new _models.Permissions(obj);
    }
  }, {
    key: "contentLinks",
    get: function get() {
      var _this2 = this;
      var contentLinks = [{
        background: _constants.Theme.blue,
        slug: 'stories',
        title: 'Stories',
        webDescription: 'Follow our structured learning path through engaging stories. Build grammar skills, practice conversations, and expand your vocabulary naturally.',
        mobileDescription: 'Follow our structured learning path through engaging stories.',
        webRoute: 'stories.home',
        mobileRoute: 'Stories',
        imgSrc: 'content_tree_icon.jpg',
        progressCurrent: this.targetLanguage.contentTreeDecksFinishedCount,
        progressTotal: this.targetLanguage.contentTreeDecksCount,
        progressText: 'Story Decks Finished'
      }, {
        background: _constants.Theme.green,
        slug: 'vocab',
        title: 'Vocab',
        webDescription: 'Create your own custom vocab trainer decks and focus on the words you want to learn.',
        mobileDescription: 'Create your own custom vocab trainer decks and focus on the words you want to learn.',
        webRoute: {
          name: 'vocab.home',
          params: {
            page: 1
          }
        },
        blockAccess: this.userIsLoaded && this.user.freeVocabDecksAvailableCount <= 0,
        mobileRoute: 'Vocab',
        imgSrc: 'vocab_trainer_icon.jpg',
        progressCurrent: this.targetLanguage.vocabTrainerWordsSeenCount,
        progressTotal: this.targetLanguage.vocabTrainerWordsCount,
        progressText: 'Words Seen',
        onClick: function onClick() {
          return _this2.onSetVocabModal('vocab');
        }
      }, {
        blockAccess: this.userIsLoaded && this.user.freeGamesAvailableCount <= 0,
        background: _constants.Theme.purple,
        slug: 'trivia',
        title: 'Trivia',
        webDescription: 'Compete with fellow learners in fast-paced trivia games. Sharpen your listening skills while discovering new words.',
        mobileDescription: 'Compete with fellow learners in fast-paced trivia games.',
        webRoute: 'trivia.home',
        mobileRoute: 'Trivia',
        imgSrc: 'trivia_icon.jpg',
        progressCurrent: this.targetLanguage.triviaQuestionsAnsweredCount,
        progressTotal: this.targetLanguage.triviaQuestionsAnsweredCount > this.targetLanguage.triviaQuestionsCount ? this.targetLanguage.triviaQuestionsAnsweredCount : this.targetLanguage.triviaQuestionsCount,
        progressText: 'Questions Answered'
      }, {
        blockAccess: this.userIsLoaded && this.user.freeGenderDecksAvailableCount <= 0,
        background: '#6f6f6f',
        slug: 'genders',
        title: this.targetLanguageId === 'DE' ? 'Der Die Das' : 'Genders',
        webDescription: 'Master genders with our fun gender trainer decks. How many nouns\' gender can you remember?',
        mobileDescription: 'Master genders with our fun gender trainer decks.',
        webRoute: {
          name: 'vocab.home',
          params: {
            page: 1
          }
        },
        mobileRoute: 'Vocab',
        imgSrc: 'der_die_das.png',
        progressCurrent: this.targetLanguage.genderCardsSeenCount,
        progressTotal: this.targetLanguage.vocabTrainerGendersCount,
        progressText: 'Gender Cards Seen',
        onClick: function onClick() {
          return _this2.onSetVocabModal('gender');
        }
      }, {
        blockAccess: this.userIsLoaded && this.user.freeCaseDecksAvailableCount <= 0,
        background: '#F886C1',
        slug: 'case',
        title: 'Cases',
        webDescription: 'Better understand German\'s four-case system with focused drills. Transform cases from confusing to second nature.',
        mobileDescription: 'Better understand German\'s four-case system with focused drills.',
        webRoute: {
          name: 'vocab.home',
          params: {
            page: 1
          }
        },
        mobileRoute: 'Vocab',
        progressCurrent: this.targetLanguage.caseCardsSeenCount,
        progressTotal: this.targetLanguage.caseTrainerWordAssociationsCount,
        progressText: 'Case Cards Seen',
        onClick: function onClick() {
          return _this2.onSetVocabModal('case');
        }
      }, {
        blockAccess: this.userIsLoaded && this.user.freeConjugationDecksAvailableCount <= 0,
        background: _constants.Theme.red,
        slug: 'conjugations',
        title: 'Conjugations',
        webDescription: 'Drill verb forms across tenses and moods until they feel natural.',
        mobileDescription: 'Drill verb forms across tenses and moods until they feel natural.',
        webRoute: {
          name: 'vocab.home',
          params: {
            page: 1
          }
        },
        mobileRoute: 'Vocab',
        imgSrc: 'conjugation.png',
        progressCurrent: this.targetLanguage.conjugationCardsSeenCount,
        progressTotal: this.targetLanguage.vocabTrainerVerbsCount,
        progressText: 'Conjugation Cards Seen',
        onClick: function onClick() {
          return _this2.onSetVocabModal('conjugation');
        }
      }, {
        blockAccess: this.userIsLoaded && this.user.freePluralDecksAvailableCount <= 0,
        background: _constants.Theme.darkBlue,
        slug: 'plural',
        title: 'Plurals',
        webDescription: 'Navigate German\'s 7 plural forms and countless exceptions. Build confidence with systematic practice.',
        mobileDescription: 'Navigate German\'s 7 plural forms and countless exceptions.',
        webRoute: {
          name: 'vocab.home',
          params: {
            page: 1
          }
        },
        mobileRoute: 'Vocab',
        imgSrc: 'plural.png',
        progressCurrent: this.targetLanguage.pluralCardsSeenCount,
        progressTotal: this.targetLanguage.vocabTrainerPluralsCount,
        progressText: 'Plural Cards Seen',
        onClick: function onClick() {
          return _this2.onSetVocabModal('plural');
        }
      }, {
        blockAccess: this.userIsLoaded && this.user.freeSynonymDecksAvailableCount <= 0,
        background: '#6a9bff',
        slug: 'synonym',
        title: 'Synonyms',
        webDescription: 'Practice noun synonyms and strengthen your active vocabulary.',
        mobileDescription: 'Practice noun synonyms and strengthen your active vocabulary.',
        webRoute: {
          name: 'vocab.home',
          params: {
            page: 1
          }
        },
        mobileRoute: 'Vocab',
        progressCurrent: this.targetLanguage.synonymCardsSeenCount,
        progressTotal: this.targetLanguage.vocabTrainerSynonymsCount,
        progressText: 'Synonym Cards Seen',
        onClick: function onClick() {
          return _this2.onSetVocabModal('synonym');
        }
      }, {
        blockAccess: this.userIsLoaded && this.user.freeNumberDecksAvailableCount <= 0,
        background: _constants.Theme.orange,
        slug: 'number',
        title: 'Numbers',
        webDescription: this.targetLanguageId === 'DE' ? 'German numbers are notoriously tricky. Practice understanding and forming them with confidence.' : 'Practice understanding and forming numbers with confidence.',
        mobileDescription: this.targetLanguageId === 'DE' ? 'German numbers are notoriously tricky. Practice understanding and forming them with confidence.' : 'Practice understanding and forming numbers with confidence.',
        webRoute: {
          name: 'vocab.home',
          params: {
            page: 1
          }
        },
        mobileRoute: 'Vocab',
        progressCurrent: this.targetLanguage.numberCardsSeenCount,
        progressTotal: this.targetLanguage.vocabTrainerNumbersCount,
        progressText: 'Number Cards Seen',
        onClick: function onClick() {
          return _this2.onSetVocabModal('number');
        }
      }];
      return contentLinks.filter(function (item) {
        return item.progressTotal > 0;
      }).filter(function (item) {
        return !['plural', 'trivia', 'case'].includes(item.slug) || _this2.targetLanguageId === 'DE';
      }).filter(function (item) {
        return !_this2.layout.isNative || item.mobileRoute != null;
      });
    }
  }, {
    key: "nativeWrapperWidth",
    get: function get() {
      if (this.layout.isNativeTablet && this.layout.viewportWidth > 620) {
        return 600;
      }
      return '100%';
    }
  }, {
    key: "site",
    get: function get() {
      var _this$user4;
      return (_this$user4 = this.user) === null || _this$user4 === void 0 ? void 0 : _this$user4.site;
    }
  }, {
    key: "showPatreonButton",
    get: function get() {
      var _this$site;
      return this.siteIsMemrev && !!((_this$site = this.site) !== null && _this$site !== void 0 && _this$site.patreonClientId);
    }
  }, {
    key: "siteId",
    get: function get() {
      return this.site ? this.site.id : null;
    }
  }, {
    key: "groupId",
    get: function get() {
      var _this$site2;
      return (_this$site2 = this.site) === null || _this$site2 === void 0 ? void 0 : _this$site2.groupId;
    }
  }, {
    key: "siteIsSeedlang",
    get: function get() {
      if (this.layout.isNative) {
        return true;
      }
      if ((0, _utils.isPresent)(this.site)) {
        return this.site.isSeedlang;
      }
      return this.siteIsSeedlangFromUrl;
    }
  }, {
    key: "siteIsMemrev",
    get: function get() {
      return !this.siteIsSeedlang;
    }
  }, {
    key: "siteIsSeedlangFromUrl",
    get: function get() {
      var url = window.location.href;
      var hostname = window.location.hostname;
      if (url.match('ngrok')) {
        var _url$match;
        // E.g.: seedlang.ngrok.io, jeremy-seedlang.eu.ngrok.io
        return (_url$match = url.match(/seedlang(\.\w+)?\.ngrok/)) !== null && _url$match !== void 0 ? _url$match : false;
      }
      if (hostname.endsWith('.localhost')) {
        var _hostname$match;
        return (_hostname$match = hostname.match(/^seedlang\./)) !== null && _hostname$match !== void 0 ? _hostname$match : false;
      }
      return !url.match('easy-languages') && !url.match('members.easy');
    }
  }, {
    key: "loadingUser",
    get: function get() {
      return !(0, _utils.isPresent)(this.user.id) && !this.user.signedOut;
    }
  }, {
    key: "userIsSignedIn",
    get: function get() {
      return this.userIsLoaded && (0, _utils.isPresent)(this.user.id);
    }
  }, {
    key: "userIsSignedInAndNotGuest",
    get: function get() {
      return this.userIsLoaded;
    }
  }, {
    key: "languageOptions",
    get: function get() {
      var abbreviations = (0, _lodash.keys)(_constants.Languages);
      return abbreviations.map(function (item) {
        return [item, _constants.Languages[item]];
      });
    }
  }, {
    key: "AiLanguageOptions",
    get: function get() {
      var abbreviations = (0, _lodash.keys)(_constants.AiLanguages);
      return abbreviations.map(function (item) {
        return [item, _constants.AiLanguages[item]];
      });
    }
  }, {
    key: "nativeLanguageOptions",
    get: function get() {
      var _this$user5;
      return this.nativeLanguageOptionsForLanguageId((_this$user5 = this.user) === null || _this$user5 === void 0 ? void 0 : _this$user5.languageId);
    }
  }, {
    key: "defaultReviewDeckId",
    get: function get() {
      return this.defaultReviewDeckIdForLanguageId(this.targetLanguageId);
    }
  }, {
    key: "defaultReviewDeckName",
    get: function get() {
      var _this$defaultReviewDe;
      return (_this$defaultReviewDe = this.defaultReviewDeck(this.targetLanguageId)) === null || _this$defaultReviewDe === void 0 ? void 0 : _this$defaultReviewDe.name;
    }
  }, {
    key: "languageOptionsForFilter",
    get: function get() {
      var abbreviations = (0, _lodash.keys)(_constants.Languages);
      return abbreviations.map(function (item) {
        return {
          id: item,
          name: _constants.Languages[item]
        };
      });
    }
  }, {
    key: "AiLanguageOptionsForFilter",
    get: function get() {
      var abbreviations = (0, _lodash.keys)(_constants.AiLanguages);
      return abbreviations.map(function (item) {
        return {
          id: item,
          name: _constants.AiLanguages[item]
        };
      });
    }
  }, {
    key: "reviewDeckOptions",
    get: function get() {
      var _this3 = this;
      return this.reviewDeckStore.indexData.filter(function (item) {
        return item.languageId === _this3.targetLanguageId && !item.archived;
      }).map(function (item) {
        return [item.id, item.name];
      });
    }
  }, {
    key: "createEventOnServer",
    value: function createEventOnServer(eventType, params) {
      this.eventStore.create({
        data: {
          eventType: eventType,
          params: params
        }
      }, _lodash.noop);
    }
  }, {
    key: "targetLanguage",
    get: function get() {
      var _this4 = this;
      if (!this.userIsLoaded) {
        return {};
      }
      var tl = this.user.targetLanguages.find(function (item) {
        return item.languageId === _this4.targetLanguageId;
      });
      return tl || this.user.defaultTargetLanguage;
    }
  }, {
    key: "userCreatedInLastWeek",
    get: function get() {
      return this.user.createdWithinLastWeek || this.user.admin;
    }
  }, {
    key: "hasTargetLanguage",
    get: function get() {
      return (0, _utils.isPresent)(this.targetLanguage);
    }
  }, {
    key: "targetLanguageId",
    get: function get() {
      var _this$user6;
      if (this.updatedDeviceLanguageId && this.updatedDeviceLanguageId !== 'all') {
        return this.updatedDeviceLanguageId;
      } else if (this.layout.deviceLanguageId && this.layout.deviceLanguageId !== 'all') {
        return this.layout.deviceLanguageId;
      } else if ((_this$user6 = this.user) !== null && _this$user6 !== void 0 && _this$user6.targetLanguageId) {
        return this.user.targetLanguageId;
      } else if (this.siteIsMemrev && (0, _utils.isPresent)(this.site)) {
        return this.site.languageId;
      }
      return 'DE';
    }
  }, {
    key: "specialCharacterList",
    get: function get() {
      var _this$site3;
      if (this.siteIsSeedlang) {
        var _this$targetLanguage;
        return ((_this$targetLanguage = this.targetLanguage) === null || _this$targetLanguage === void 0 || (_this$targetLanguage = _this$targetLanguage.language) === null || _this$targetLanguage === void 0 ? void 0 : _this$targetLanguage.specialCharacterList) || [];
      }
      return ((_this$site3 = this.site) === null || _this$site3 === void 0 || (_this$site3 = _this$site3.language) === null || _this$site3 === void 0 ? void 0 : _this$site3.specialCharacterList) || [];
    }
  }, {
    key: "targetLanguageName",
    get: function get() {
      if (this.targetLanguageId) {
        return _constants.Languages[this.targetLanguageId];
      }
    }
  }, {
    key: "wasUiElementSeen",
    value: function wasUiElementSeen(element) {
      if (!this.userIsLoaded) {
        return true;
      }
      return this.user.wasUiElementSeen(element);
    }
  }, {
    key: "designateUiElementAsSeen",
    value: function designateUiElementAsSeen(uiElement) {
      if ((0, _utils.isPresent)(uiElement) && this.userIsLoaded && !this.user.wasUiElementSeen(uiElement)) {
        this.user.designateUiElementAsSeen(uiElement);
        this.authUserStore.update({
          data: {
            ui_elements_seen: this.user.uiElementsSeen
          }
        });
      }
    }
  }, {
    key: "isUnpublishedAccessBlocked",
    get: function get() {
      var _this$site4;
      return this.siteIsMemrev && !((_this$site4 = this.site) !== null && _this$site4 !== void 0 && _this$site4.published) && this.getCookieValue('allowUnpublishedAccess') !== 'yes' && (0, _utils.isBlank)(this.getCookieValue('early-access-token'));
    }
  }, {
    key: "signOut",
    value: function signOut() {
      var _this$user7;
      if (this.isDevelopment && !this.layout.isNative) {
        (0, _utils.deleteAllCookies)(); // useful for signing in as other users
      }
      _tree_ui["default"].clearTrees();
      this.reviewDeckStore.clearIndexData();
      _after_auth["default"].clear();
      if (this.isUnpublishedAccessBlocked) {
        this.route = 'unpublished';
      } else if (this.siteIsMemrev && (_this$user7 = this.user) !== null && _this$user7 !== void 0 && (_this$user7 = _this$user7.site) !== null && _this$user7 !== void 0 && _this$user7.signedOutHomePageRoute) {
        var _this$user8;
        this.route = (_this$user8 = this.user) === null || _this$user8 === void 0 || (_this$user8 = _this$user8.site) === null || _this$user8 === void 0 ? void 0 : _this$user8.signedOutHomePageRoute;
      }
      this.user.set('signedOut', true);
      this.userTreeNodeStore.clearIndexData();
      this.domainString = this.site.domainString;
      this.authenticateStore.signOut({}, this.siteIsSeedlang ? this.afterSignOutSeedlang : this.afterSignOutMemrev);
    }
  }, {
    key: "onNewRoute",
    value: function onNewRoute() {
      this.pageExpanded = false;
      this.pageHasScrolled = false;
      this.notificationsOpened = false;
      this.streakPopupOpened = false;
    }
  }, {
    key: "env",
    get: function get() {
      return !this.layout.isNative && (window.location.href.match('localhost') || window.location.href.match('ngrok')) ? 'development' : 'production';
    }
  }, {
    key: "isDevelopment",
    get: function get() {
      return this.env === 'development';
    }
  }, {
    key: "loadReviews",
    value: function loadReviews(cardId) {
      this.loadingReviews = true;
      this.reviewStore.getIndex({
        ids: {
          cardId: cardId
        },
        sort: '-created_at'
      }, this.afterGetReviews.bind(this));
    }
  }, {
    key: "detectDataSaver",
    value: function detectDataSaver() {
      if ('connection' in navigator) {
        if (navigator.connection.saveData === true) {
          this.usingDataSaverHeader = true;
        }
      }
    }
  }, {
    key: "closeDeck",
    value: function closeDeck() {
      this.loadUser(null, {
        forceRefresh: true
      });
      this.userTreeNodeStore.getIndex();
      _exercise_ui["default"].set('assignedExercise', null);
      if (_deck_ui["default"].deck.deckType === 'review') {
        // need to update deck counts after finishing review deck
        this.reloadReviewDecks = true;
      }
      _deck_ui["default"].onCloseDeck();
      this.xpState.clearAllAnimations();
    }
  }, {
    key: "paymentMigrationEnabled",
    get: function get() {
      return !!this.site.patreonClientId || this.env === 'development' || this.user.admin || window.location.search === '?test';
    }
  }, {
    key: "isPaymentMigrationInProgress",
    get: function get() {
      var _this$user$paymentMig;
      return ((_this$user$paymentMig = this.user.paymentMigration) === null || _this$user$paymentMig === void 0 ? void 0 : _this$user$paymentMig.status) && this.user.paymentMigration.isInProgress;
    }
  }, {
    key: "isPaymentMigrationStartable",
    get: function get() {
      var _this$user$paymentMig2, _this$user$patreonUse;
      return !!this.site.patreonClientId && this.paymentMigrationEnabled && ((_this$user$paymentMig2 = this.user.paymentMigration) === null || _this$user$paymentMig2 === void 0 ? void 0 : _this$user$paymentMig2.isUnstarted) && this.user.isMember && ((_this$user$patreonUse = this.user.patreonUser) === null || _this$user$patreonUse === void 0 ? void 0 : _this$user$patreonUse.isPatreonActive) && (!this.user.admin || this.env === 'development');
    }
  }, {
    key: "shouldBlockPerksForMigration",
    get: function get() {
      var _this$user$patreonUse2, _this$user$paymentMig3;
      if (!!this.site.patreonClientId || !this.paymentMigrationEnabled || !this.user.isMember || !((_this$user$patreonUse2 = this.user.patreonUser) !== null && _this$user$patreonUse2 !== void 0 && _this$user$patreonUse2.isPatreonActive)) {
        return false;
      }
      // Block users who haven't completed migration (haven't reached waiting_for_patreon_expiry)
      var blockingStatuses = ['setting_up', 'stripe_payment_setup_started', 'waiting_for_patreon_cancellation'];
      return ((_this$user$paymentMig3 = this.user.paymentMigration) === null || _this$user$paymentMig3 === void 0 ? void 0 : _this$user$paymentMig3.status) && blockingStatuses.includes(this.user.paymentMigration.status);
    }
  }, {
    key: "vocabBlockedUntilMigrated",
    get: function get() {
      return this.shouldBlockPerksForMigration && this.site.blockVocabIfNotMigrated;
    }
  }, {
    key: "exercisesBlockedUntilMigrated",
    get: function get() {
      var blocked = this.shouldBlockPerksForMigration && this.site.blockExercisesIfNotMigrated;
      if (blocked) {
        console.log('[Exercises Blocked Until Migrated]', 'Exercises are blocked until migration is complete');
      }
      return blocked;
    }
  }, {
    key: "userIsGroupAdmin",
    get: function get() {
      var _this$site5;
      return this.user.isAdminForSite((_this$site5 = this.site) === null || _this$site5 === void 0 ? void 0 : _this$site5.id);
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "allowPageScroll", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "notificationsOpened", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "streakPopupOpened", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "usingDataSaverHeader", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "registrationSubmitted", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hideOnboarding", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "deletedAccountEmail", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "expandedEmailRegistrationFields", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "loadingReviews", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "blockRouteToHome", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "reloadReviewDecks", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "currentlyViewedMembership", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "routeToMobile", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "vocabWordTypeId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "nativeDevice", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "mobileTabChangeTimeStamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "showUpdateAppModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "showUpdateLangModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "showImagePickerModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "showVocabModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "clickedLinkId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "updatedDeviceLanguageId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "showFirstDeckCompletionModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "onboardingDeckType", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "onboardingDeckId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "onboardingTreeNodeId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "pageHasScrolled", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "pageExpanded", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "contentTreeScrollPosition", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "worksheetGridScrollPosition", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "contractedModulesAry", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "wordStores", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "wordSentenceStores", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "conjugatedVerbStringStores", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "onboardingLevelId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "onboardingLanguageId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "isBrowser", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  }
}), _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "permissions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "permissions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contentLinks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "contentLinks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nativeWrapperWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nativeWrapperWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "site", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "site"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPatreonButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPatreonButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "groupId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteIsSeedlang", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteIsSeedlang"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteIsMemrev", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteIsMemrev"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteIsSeedlangFromUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteIsSeedlangFromUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadingUser", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "loadingUser"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsSignedIn", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsSignedIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsSignedInAndNotGuest", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsSignedInAndNotGuest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languageOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languageOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "AiLanguageOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "AiLanguageOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nativeLanguageOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nativeLanguageOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultReviewDeckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultReviewDeckId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultReviewDeckName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultReviewDeckName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languageOptionsForFilter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languageOptionsForFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "AiLanguageOptionsForFilter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "AiLanguageOptionsForFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewDeckOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reviewDeckOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetLanguage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetLanguage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userCreatedInLastWeek", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userCreatedInLastWeek"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasTargetLanguage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasTargetLanguage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetLanguageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetLanguageId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "specialCharacterList", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "specialCharacterList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetLanguageName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetLanguageName"), _class.prototype), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "userRequestPending", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "loadUser", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;
    return function (callback) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (_this5.authUserStore.hasShowData && !options.forceRefresh) {
        if ((0, _lodash.isFunction)(callback)) callback(_this5.authUserStore.showData);
        if (options.successCallback) options.successCallback(_this5.authUserStore.showData);
        return;
      }
      var callbacks = {
        success: function success(resp) {
          if ((0, _lodash.isFunction)(callback)) callback(resp);
          if (options.successCallback) options.successCallback(resp);
        },
        failure: function failure(resp) {
          if (options.failureCallback) options.failureCallback(resp);
        },
        requestError: function requestError(error) {
          if (options.onRequestError) options.onRequestError(error);
        }
      };
      if (_this5.userRequestPending) {
        _this5.userRequestCallbacks.push(callbacks);
        return;
      }
      _this5.userRequestPending = true;
      _this5.userRequestCallbacks.push(callbacks);
      _this5.authUserStore.getShow({}, function (resp) {
        _this5.setAuthUserStoreShowData(resp);
        _this5.userRequestPending = false;
        _this5.userRequestCallbacks.forEach(function (cbs) {
          return cbs.success(resp);
        });
        _this5.userRequestCallbacks = [];
      }, _objectSpread(_objectSpread({}, options), {}, {
        failureCallback: function failureCallback(resp) {
          _this5.userRequestPending = false;
          _this5.userRequestCallbacks.forEach(function (cbs) {
            return cbs.failure(resp);
          });
          _this5.userRequestCallbacks = [];
        },
        onRequestError: function onRequestError(error) {
          _this5.userRequestPending = false;
          _this5.userRequestCallbacks.forEach(function (cbs) {
            return cbs.requestError(error);
          });
          _this5.userRequestCallbacks = [];
        }
      }));
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "wasUiElementSeen", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "wasUiElementSeen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "designateUiElementAsSeen", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "designateUiElementAsSeen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isUnpublishedAccessBlocked", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUnpublishedAccessBlocked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "signOut", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "signOut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onNewRoute", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onNewRoute"), _class.prototype), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "toggleNotificationsOpened", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;
    return function () {
      _this6.streakPopupOpened = false;
      _this6.notificationsOpened = !_this6.notificationsOpened;
      if (_this6.notificationsOpened) {
        _this6.createEvent('header - open notifications');
        var limit = _this6.siteIsSeedlang ? 10 : 5;
        _this6.notificationStore.getIndex({
          limit: limit
        }, _this6.afterGetNotificationsIndex);
      }
    };
  }
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "toggleStreakPopupOpened", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;
    return function () {
      _this7.notificationsOpened = false;
      _this7.streakPopupOpened = !_this7.streakPopupOpened;
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "env", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "env"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDevelopment", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDevelopment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "detectDataSaver", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "detectDataSaver"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeDeck"), _class.prototype), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "reloadFeed", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;
    return function () {
      _this8.feedEntryStore.getIndex();
    };
  }
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "gotoPrivacy", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      _overlay_ui["default"].addOverlay('privacy', {
        overlayTitle: 'Privacy'
      });
    };
  }
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "gotoPartners", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      _overlay_ui["default"].addOverlay('partners', {
        overlayTitle: 'Partners'
      });
    };
  }
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "gotoSettings", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      _overlay_ui["default"].addOverlay('settings', {
        overlayTitle: 'Settings'
      });
    };
  }
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "gotoFaq", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      _overlay_ui["default"].addOverlay('faq', {
        overlayTitle: 'FAQ'
      });
    };
  }
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "gotoContact", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      _overlay_ui["default"].addOverlay('contact', {
        overlayTitle: 'Contact'
      });
    };
  }
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "gotoProfile", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;
    return function (user) {
      if (_this9.layout.isMobile) {
        _overlay_ui["default"].addOverlay('profile', {
          overlayTitle: 'Profile',
          params: {
            userId: user.id
          }
        });
      } else {
        _this9.routeStore.routeToNamed('profiles.show', {
          userId: user.id
        });
      }
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "paymentMigrationEnabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentMigrationEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPaymentMigrationInProgress", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPaymentMigrationInProgress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPaymentMigrationStartable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPaymentMigrationStartable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shouldBlockPerksForMigration", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldBlockPerksForMigration"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabBlockedUntilMigrated", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabBlockedUntilMigrated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exercisesBlockedUntilMigrated", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exercisesBlockedUntilMigrated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsGroupAdmin", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsGroupAdmin"), _class.prototype), _class);
var _default = exports["default"] = new AppUI();